<template>
    <header v-if="plugin" id="header__section">
        <div class="container">
            <div class="header__top">
                <div class="header__top--left">
                    <plugin-logo :size="128" :type="plugin.image.type" :path="plugin.image.path"></plugin-logo>
                    <div class="header__left--meta">
                        <h1>{{plugin.name}}</h1>
                        <span v-if="versions" class="status" :class="getStatusClass(versions.latest.publish_status)">{{$t('page.listing.status.title')}} <span>{{getStatusText(versions.latest.publish_status)}}</span></span>
                        <span v-if="versions" class="version">{{$t('page.creator_edit.version')}} <span>{{versions.latest.version_number}}</span></span>
                        <span v-if="versions && plugin.published == 1" class="rating">
                            <svg width="14" height="14" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M23.973,8.336c-0.07,-0.201 -0.26,-0.336 -0.473,-0.336h-8.146l-2.882,-7.666c-0.071,-0.2 -0.259,-0.334 -0.472,-0.334c-0.213,0 -0.401,0.134 -0.472,0.334l-2.882,7.666h-8.146c-0.213,0 -0.403,0.135 -0.473,0.336c-0.07,0.202 -0.004,0.425 0.164,0.557l6.723,5.783l-2.889,8.666c-0.069,0.206 0.004,0.435 0.18,0.562c0.176,0.128 0.414,0.128 0.59,-0.001l7.205,-5.283l7.205,5.283c0.176,0.129 0.414,0.129 0.59,0.001c0.176,-0.128 0.249,-0.356 0.18,-0.562l-2.889,-8.666l6.723,-5.783c0.168,-0.132 0.234,-0.355 0.164,-0.557Z" fill="#84888E"></path><path fill="none" d="M0,0h24v24h-24Z"></path></svg>
                            {{beautifyRating(plugin.rating.average)}}
                        </span>
                        <span v-if="versions && plugin.published == 1" class="downloads">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14px" height="14px" viewBox="0 0 33 33" version="1.1"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="file-video-download" transform="translate(0.300000, 0.266549)" fill="#84888E" fill-rule="nonzero"><g id="Group"><path d="M16,32 C24.8369231,32 32,24.8369231 32,16 C32,7.16553846 24.8369231,0 16,0 C7.16307692,0 0,7.16553846 0,16 C0,24.8369231 7.16307692,32 16,32 Z M9.84615385,17.2307692 C10.3261538,16.7507692 11.1064615,16.7507692 11.5864615,17.2307692 L14.7692308,20.4135385 L14.7692308,8.61538462 C14.7692308,7.936 15.3206154,7.38461538 16,7.38461538 C16.6793846,7.38461538 17.2307692,7.936 17.2307692,8.61538462 L17.2307692,20.4135385 L20.4135385,17.2307692 C20.8935385,16.7507692 21.6738462,16.7507692 22.1538462,17.2307692 C22.6338462,17.7107692 22.6338462,18.4910769 22.1538462,18.9686154 L16.8713846,24.256 C16.3913846,24.7335385 15.6110769,24.7335385 15.1310769,24.256 L9.84615385,18.9686154 C9.36615385,18.4910769 9.36615385,17.7107692 9.84615385,17.2307692 Z" id="Shape"/></g></g></g></svg>
                            {{beautifyDownloads(plugin.downloads)}}</span>
                        <span v-if="versions && plugin.published == 1" class="view"><router-link :to="{path: '/detail/' + plugin.id + '/overview'}">{{$t('page.creator_edit.view_in_library')}}</router-link></span>
                    </div>
                </div>
                <div v-if="versions" class="header__top--right">
                    <btn v-if="versions.latest && versions.latest.publish_status == 0 || versions.latest && versions.latest.publish_status == 3" @click="updateVersionStatus('requestPublish', versions.latest)" :text="$t('page.listing.submit')" />
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    import axios from 'axios';
    import PluginLogo from '@/components/PluginLogo.vue';
    import Btn from '@/components/Button.vue';
    export default {
        name: 'CreatorHeader',
        components: {
            PluginLogo,
            Btn
        },
        props: {
            plugin: {
                type: Object,
                required: true,
            },
            versions: {
                type: Object,
                required: true,
            }
        },
        methods: {
            updateVersionStatus(task, version) {
                this.$store.dispatch('addNotification', {title: this.$t('notification.version_publish_request'), text: this.$t('notification.version_publish_request_txt'), type: 'info'});
                var data = new FormData();
                data.append('task', task);
                data.append('company_name', this.$store.state.userData.company_displayname);
                data.append('company_id', this.$store.state.userData.company_id);
                data.append('plugin_name', this.plugin.name);
                data.append('plugin_id', this.plugin.plugin_id);
                data.append('version_number', version.version_number);
                data.append('version_id', version.id);
                data.append('user_id', this.$store.state.userData.user_id);
                
                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    url: 'https://api.library.loxone.com/updateVersionStatus',
                    data: data,
                }).then(response => {
                    location.reload();
                });
            },
            beautifyDownloads(downloads) {
                if(downloads < 50) {
                    return this.$t('downloads.less_than_50');
                } else if(downloads < 100) {
                    return '50+ Downloads';
                } else {
                    return Math.floor(downloads/100)*100 + '+ Downloads'
                }
            },
            beautifyRating(rating) {
                return (rating/100)*100;
            },
            getStatusText(status) {
                switch(status) {
                    case 0:
                        return this.$t('status.draft');			// Draft
                    case 1:
                        return this.$t('status.review');		// In Review
                    case 2:
                        return this.$t('status.published');     // Published
                    case 3:
                        return this.$t('status.declined');      //  Declined
                    case 9:
                        return this.$t('status.archive');      //  Archive
                }
            },
            getStatusClass(status) {
                switch(status) {
                    case 0:
                        return 'status--draft';         // Draft
                    case 1:
                        return 'status--review';        // In Review
                    case 2:
                        return 'status--published';     // Published - Public
                    case 4:
                        return 'status--declined';      // Declined
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    header{
        .container{
            padding: 0 20px;
            box-sizing: border-box;
        }
        .header__top{
            display: flex;
            justify-content: space-between;
        }
        .status, .version{
            margin-right: 32px;
            font-size: 14px;
            line-height: 20px;
            color: #575C61;
            font-weight: bold;
            
            &.status--review span{
                    color: #F7B55C;
            }
            &.status--published span{
                    color: #69C350;
            }
        }
        .header__top--left{
            display: flex;
        }
    }
    #header__section{
        padding-bottom: 30px;
    }
</style>